declare namespace $ {

	type $mol_view__sub_shm_hitalama_process_logs_row_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_logs_row_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_logs_row_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_speck__value_shm_hitalama_process_logs_row_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_logs_row['started_at'] >
		,
		ReturnType< $mol_speck['value'] >
	>
	type $mol_view__sub_shm_hitalama_process_logs_row_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_process_logs_row_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_logs_row['child_rows'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_hitalama_process_logs_row__process_shm_hitalama_process_logs_row_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_logs_row['child_process'] >
		,
		ReturnType< $shm_hitalama_process_logs_row['process'] >
	>
	export class $shm_hitalama_process_logs_row extends $mol_view {
		status( ): string
		Status( ): $mol_view
		duration( ): string
		Duration( ): $mol_view
		name( ): string
		Name( ): $mol_view
		started_at( ): string
		Started( ): $mol_speck
		Head( ): $mol_view
		child_rows( ): readonly(any)[]
		Children( ): $mol_list
		children_visible( ): readonly(any)[]
		child_process( id: any): any
		process( ): any
		sub( ): readonly(any)[]
		Child( id: any): $shm_hitalama_process_logs_row
	}
	
}

//# sourceMappingURL=row.view.tree.d.ts.map